const __concat__ = (name, text, m_x, m_y, src = '', others = {}) => {

	src = src ? src : `/static/map/${name}.png`

	return {
		name: name,
		text: text,
		src: src,
		x: others.x || 0,
		y: others.y || 0,
		m_x: m_x || 0,   //地图的左上角最大值
		m_y: m_y || 0,   // 地图的右上角最大值
		w: others.w || 0, // 真实像素宽度
		h: others.h || 0 // 真实像素高度
	}
}

const __wh__ = (w, h) => {
	return {
		w: w,
		h: h,
	}
}

const aolaiguo = __concat__("aolaiguo", "傲来国", 220, 147, "/static/map/aolaiguo.jpg", __wh__(1920, 1296))
const baoxiangguo = __concat__("baoxiangguo", "宝象国", 159, 119, '', __wh__(866, 650))
const beijuluzhou = __concat__("beijuluzhou", "北俱芦洲", 227, 169, '', __wh__(1056, 781))
const boyuedong = __concat__("boyuedong", "波月洞", 95, 143, '', __wh__(440, 660))
const changshoucun = __concat__("changshoucun", "长寿村", 159, 209, '', __wh__(427, 554))
const difu = __concat__("difu", "地府", 157 , 117, '', __wh__(569, 376))
const datangjingwai = __concat__("datangjingwai", "大唐境外", 638, 118, '', __wh__(854, 160))
const diyumigongsanceng = __concat__("diyumigongsanceng", "地狱迷宫三层", 119, 89, '', __wh__(589, 441))
const haidimigong = __concat__("haidimigong", "海底迷宫", 63, 47, '', __wh__(581, 439))
const huaguoshan = __concat__("huaguoshan", "花果山", 159, 119, '', __wh__(781, 589))
const jiangnanyewai = __concat__("jiangnanyewai", "江南野外", 159, 119, '', __wh__(1600, 1200))
const jianye = __concat__("jianye", "建邺城", 288, 144, "/static/map/jianye.jpg", __wh__(1920, 960))
const nvercun = __concat__("nvercun", "女儿村", 127, 143, '', __wh__(864, 972))
const nvwashenji = __concat__("nvwashenji", "女娲神迹", 191, 143, '', __wh__(866, 581))
const putuoshan = __concat__("putuoshan", "普陀山", 95, 71, '', __wh__(845, 631))
const qilinshan = __concat__("qilinshan", "麒麟山", 190, 142, '', __wh__(1002, 685))
const tiangong = __concat__("tiangong", "天宫", 252, 166, '', __wh__(1175, 781))
const wanzishan = __concat__("wanzishan", "碗子山", 95, 191, '', __wh__(272, 537))
const wuzhuangguan = __concat__("wuzhuangguan", "五庄观", 99, 74, '', __wh__(1002, 741))
const xiliangnvguo = __concat__("xiliangnvguo", "西凉女国", 163, 123, '', __wh__(585, 452))
const zhuziguo = __concat__("zhuziguo", "朱紫国", 191, 119, '', __wh__(691, 441))


export {
	aolaiguo,
	baoxiangguo,
	beijuluzhou,
	boyuedong,
	changshoucun,
	difu,
	datangjingwai,
	diyumigongsanceng,
	haidimigong,
	huaguoshan,
	jiangnanyewai,
	jianye,
	nvercun,
	nvwashenji,
	putuoshan,
	qilinshan,
	tiangong,
	wanzishan,
	wuzhuangguan,
	xiliangnvguo,
	zhuziguo
}
